import { createSelector } from 'reselect';
import { AppState } from '../reducers/appReducer';
import { RootStore } from '../reducers/index';

const appStateSelector = createSelector(
  (state: RootStore) => state.app,
  (appState: AppState) => appState,
);

export const appConfigLoadStatusSelector = createSelector(
  appStateSelector,
  (appState: AppState) => appState.appConfigLoadStatus,
);

export const registerAccessSelector = createSelector(
  appStateSelector,
  (appState: AppState) => appState.registerAccess,
);

export const applicationSentSelector = createSelector(
  appStateSelector,
  (appState: AppState) => appState.applicationSent,
);

export const formInitialValuesSelector = createSelector(
  appStateSelector,
  (appState: AppState) => appState.formInitialValues,
);

export const messageFromBackendSelector = createSelector(
  appStateSelector,
  (appState: AppState) => appState.messageFromBackend,
);

export const loaderSelector = createSelector(
  appStateSelector,
  (appState: AppState) => appState.loader,
);

export const serverErrorMessageSelector = createSelector(
  appStateSelector,
  (appState: AppState) => appState.serverErrorMessage,
);

export const errorPageSelector = createSelector(
  appStateSelector,
  (appState: AppState) => appState.errorPage,
);

export const validationErrorsSelector = createSelector(
  appStateSelector,
  (appState: AppState) => appState.validationErrors,
);

export const resultCodeSelector = createSelector(
  appStateSelector,
  (appState: AppState) => appState.resultCode,
);

export const urlParamsSelector = createSelector(
  appStateSelector,
  (appState: AppState) => appState.urlParams,
);

export const previewFormSelector = createSelector(
  appStateSelector,
  (appState: AppState) => appState.previewForm,
);

export const languageSelector = createSelector(
  appStateSelector,
  (appState: AppState) => appState.language,
);

export const appErrorSelector = createSelector(
  appStateSelector,
  (appState: AppState) => appState.appError,
);

export const userAlreadyAvailableFormPathSelector = createSelector(
  appStateSelector,
  (appState: AppState) => appState.userAlreadyAvailableFormPath,
);

export const accountRegisterUrlSelector = createSelector(
  appStateSelector,
  (appState: AppState) => appState.accountRegisterUrl,
);
